import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import ForgetPassword from '@/views/ForgetPassword.vue'
import Home from '@/views/Home.vue'
import MyAccount from '@/views/account/MyAccount.vue'
import RegisterDemo from '@/views/account/RegisterDemo.vue'
import ModifyPassword from '@/views/account/ModifyPassword.vue'
import AccountVerify from '@/views/verify/AccountVerify.vue'
import VerifyError from '@/views/verify/VerifyError.vue'
import UploadPhoto from '@/views/verify/UploadPhoto.vue'
import RegisterBank from '@/views/profile/RegisterBank.vue'
import TransferIn from '@/views/money/TransferIn.vue'
import TransferOut from '@/views/money/TransferOut.vue'
import TransferHistory from '@/views/money/TransferHistory.vue'
import BankList from '@/views/profile/BankList.vue'


Vue.use(VueRouter)

const routes = [
	{
		path: '',
		redirect: '/login',
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {requireAuth: false},
	},
	{
		path: '/register',
		name: 'Register',
		component: Register,
		meta: {requireAuth: false},
	},
	{
		path: '/forgetPassword',
		name: 'ForgetPassword',
		component: ForgetPassword,
		meta: {requireAuth: false},
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		children:[
			{
				path: '/myAccount',
				name: 'MyAccount',
				component: MyAccount,
				meta: {requireAuth: true},
			},
			{
				path: '/registerDemo',
				name: 'RegisterDemo',
				component: RegisterDemo,
				meta: {requireAuth: true},
			},
			{
				path: '/modifyPassword',
				name: 'ModifyPassword',
				component: ModifyPassword,
				meta: {requireAuth: true},
			},
			{
				path: '/accountVerify',
				name: 'AccountVerify',
				component: AccountVerify,
				meta: {requireAuth: true},
			},
			{
				path: '/verifyError',
				name: 'VerifyError',
				component: VerifyError,
				meta: {requireAuth: true},
			},
			{
				path: '/uploadPhoto',
				name: 'UploadPhoto',
				component: UploadPhoto,
				meta: {requireAuth: true},
			},
			{
				path: '/registerBank',
				name: 'RegisterBank',
				component: RegisterBank,
				meta: {requireAuth: true},
			},
			{
				path: '/transferIn',
				name: 'TransferIn',
				component: TransferIn,
				meta: {requireAuth: true},
			},
			{
				path: '/transferOut',
				name: 'TransferOut',
				component: TransferOut,
				meta: {requireAuth: true},
			},
			{
				path: '/transferHistory',
				name: 'TransferHistory',
				component: TransferHistory,
				meta: {requireAuth: true},
			},
			{
				path: '/bankList',
				name: 'BankList',
				component: BankList,
				meta: {requireAuth: true},
			},
		]
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior: () => {
		history.pushState(null, null, document.URL)
	}
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
return originalPush.call(this, location).catch(err => err)
}

export default router
